import React, { useState } from "react";

const KakaoDirection = () => {
  const [start, setStart] = useState({ name: "", lat: "", lng: "" });
  const [end, setEnd] = useState({ name: "", lat: "", lng: "" });
  const [mode, setMode] = useState("car"); // car | walk | bicycle | traffic

  const handleNavigate = () => {
    if (!start.lat || !start.lng || !end.lat || !end.lng) {
      alert("출발지와 목적지 좌표를 입력해주세요!");
      return;
    }

    const url = `https://map.kakao.com/link/by/${mode}/${encodeURIComponent(
      start.name
    )},${start.lat},${start.lng}/${encodeURIComponent(
      end.name
    )},${end.lat},${end.lng}`;

    window.open(url, "_blank"); // 새 탭으로 열기
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>🚗 카카오맵 길찾기</h2>

      <div style={{ marginBottom: "10px" }}>
        <h4>출발지</h4>
        <input
          type="text"
          placeholder="출발지 이름"
          value={start.name}
          onChange={(e) => setStart({ ...start, name: e.target.value })}
        />
        <input
          type="text"
          placeholder="위도"
          value={start.lat}
          onChange={(e) => setStart({ ...start, lat: e.target.value })}
        />
        <input
          type="text"
          placeholder="경도"
          value={start.lng}
          onChange={(e) => setStart({ ...start, lng: e.target.value })}
        />
      </div>

      <div style={{ marginBottom: "10px" }}>
        <h4>도착지</h4>
        <input
          type="text"
          placeholder="도착지 이름"
          value={end.name}
          onChange={(e) => setEnd({ ...end, name: e.target.value })}
        />
        <input
          type="text"
          placeholder="위도"
          value={end.lat}
          onChange={(e) => setEnd({ ...end, lat: e.target.value })}
        />
        <input
          type="text"
          placeholder="경도"
          value={end.lng}
          onChange={(e) => setEnd({ ...end, lng: e.target.value })}
        />
      </div>

      <div style={{ marginBottom: "10px" }}>
        <label>이동수단 선택: </label>
        <select value={mode} onChange={(e) => setMode(e.target.value)}>
          <option value="car">🚗 자동차</option>
          <option value="traffic">🚉 대중교통</option>
          <option value="walk">🚶 도보</option>
          <option value="bicycle">🚴 자전거</option>
        </select>
      </div>

      <button onClick={handleNavigate}>길찾기 보기</button>
    </div>
  );
};

export default KakaoDirection;
